/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CompanyAlias = {
  readonly id?: number;
  name: string;
  kind: CompanyAlias.kind;
  external_id?: string | null;
};
export namespace CompanyAlias {
  export enum kind {
    FORMER_NAME = 'former_name',
    ACQUIRED = 'acquired',
  }
}

